import { useState } from "react";
import { subscribeToNewsletter } from "../services/newsletterService";

const Newsletter = () => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage(""); // Clear previous messages

        if (!email) {
            setMessage("Please enter a valid email.");
            return;
        }

        try {
            const response = await subscribeToNewsletter(email);
            setMessage(response.message || "Subscribed successfully!");
            setEmail(""); // Clear input after successful submission
        } catch (error) {
            setMessage("Failed to subscribe. Please try again later.");
        }
    };

    return (
        <div className="footer-widget">
            <h3 className="title">Newsletter</h3>
            <div className="newsletter">
                <p>Subscribe to our newsletter for the latest updates.</p>
                <form onSubmit={handleSubmit}>
                    <input
                        className="form-control"
                        type="email"
                        placeholder="Your email here"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <button className="btn" type="submit">Submit</button>
                </form>
                {message && <p className="message">{message}</p>}
            </div>
           <div className="social">
                <a href="#" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-twitter"></i>
                </a>
                <a href="https://www.facebook.com/factbazaar.official" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-facebook-f"></i>
                </a>
                <a href="#" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-linkedin-in"></i>
                </a>
                <a href="#" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-instagram"></i>
                </a>
                <a href="#" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-youtube"></i>
                </a>
            </div>

        </div>
    );
};

export default Newsletter;
